import { useSignUpContext } from "./context";
import { SignUpFormClient } from "./forms/SignUpFormClient";
import { SignUpFormOperator } from "./forms/SignUpFormOperator";

export const SignUpForms = () => {
  const { userTypeData } = useSignUpContext();
  if (!userTypeData) throw Error("userTypeData is undefined");

  switch (userTypeData.type) {
    case "operator":
      return <SignUpFormOperator />;
    default:
      return <SignUpFormClient />;
  }
};
